import type { FunctionComponent } from 'react';

import { Form } from '@kanda-libs/ks-component-ts';
import { BreakPoints, Loader } from '@kanda-libs/ks-design-library';

import Desktop from './Desktop';
import Mobile from './Mobile';
import useQuoteForm from './useQuoteForm';

const Content: FunctionComponent = function () {
  const { form, onSubmit, isSubmitting, ...rest } = useQuoteForm();
  return (
    <Form form={form} onSubmit={onSubmit} id="aip-loan-form">
      <BreakPoints
        mobile={<Mobile isSubmitting={isSubmitting} {...rest} />}
        desktop={<Desktop isSubmitting={isSubmitting} {...rest} />}
      />
      <Loader isLoading={isSubmitting} />
    </Form>
  );
};

Content.displayName = 'Quote-Content-view';

export default Content;
